import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

export const getBehavior = (params) => {
    const { id, pathsContext } = params;

    return (dispatch) =>
        VerbFetch(`${pathsContext.serverUrl}/behaviors/${id}`).then((body) => {
            dispatch({
                type: ACTIONS.GET_BEHAVIOR,
                payload: {
                    behavior: body
                }
            });
        });
};

export const postBehavior = (params) => {
    const { body, pathsContext } = params;
    const uri = `${pathsContext.adminServerUrl}/behaviors`;
    const fetchOptions = {
        method: 'POST',
        body
    };
    return (dispatch) => {
        dispatch({
            type: ACTIONS.POST_BEHAVIOR_START,
            payload: {
                body
            }
        });
        return VerbFetch(uri, fetchOptions)
            .then((response) => {
                dispatch({
                    type: ACTIONS.POST_BEHAVIOR_SUCCESS,
                    payload: {
                        behavior: response
                    }
                });
                return response;
            })
            .catch((err) => err);
    };
};

export const putBehavior = (params) => {
    const { id, body, pathsContext } = params;
    const uri = `${pathsContext.adminServerUrl}/behaviors/${id}`;
    const fetchOptions = {
        method: 'PUT',
        body
    };
    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_BEHAVIOR_START,
            payload: {
                body
            }
        });
        return VerbFetch(uri, fetchOptions)
            .then((response) => {
                dispatch({
                    type: ACTIONS.PUT_BEHAVIOR_SUCCESS,
                    payload: {
                        behavior: response
                    }
                });
                return response;
            })
            .catch((err) => err);
    };
};

export const getManyBehaviors = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.serverUrl}/behaviors`;
    const url = buildQueryString(rest, baseUrl);

    return (dispatch) =>
        VerbFetch(url)
            .then((body) => {
                dispatch({
                    type: ACTIONS.GET_MANY_BEHAVIORS,
                    payload: {
                        behaviors: body
                    }
                });
                return body;
            })
            .catch(console.error);
};
